var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"margin-top":"20px"}},[_c('div',{staticStyle:{"width":"50%","margin":"0 auto"}},[_c('el-alert',{attrs:{"title":_vm.errorContent,"type":"warning","description":`出错代码：${_vm.status}`,"closable":false,"show-icon":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }